<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <tsl-drawer
    :footer-style="{ textAlign: 'left' }"
    :title="`开通` + service.title + '服务'"
    :width="640"
    :visible="visible"
    :bodyStyle="{ marginBottom: '46px' }"
    @close="handleCancel"
    class="subscribe-service-drawer"
  >
    <div class="lump">
      <h5>产品规格</h5>
      <a-radio-group v-model:value="version" @change="typeChecked">
        <a-radio-button value="1">基础版</a-radio-button>
        <a-radio-button value="2">高级版</a-radio-button>
      </a-radio-group>
    </div>
    <div class="lump">
      <h5>计费方式</h5>
      <span class="way">使用时长和购买功能模块，枚举定价</span>
    </div>
    <div class="lump">
      <h5>计费价格</h5>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        class="table-component"
      >
        <template #bodyCell="{ column, text }">
          <template v-if="column.key === 'discount'">
            <span class="discount">{{ text }}</span>
          </template>
        </template>
      </a-table>
    </div>
    <div class="lump">
      <h5>购买时长</h5>
      <a-select
        v-model:value="duration"
        dropdownClassName="search-select-dropdown"
        :options="options"
      />
    </div>
    <div class="lump">
      <h5>服务金额</h5>
      <div class="price">
        <!-- <span class="amount">{{ amount }}</span> -->
        <span class="amount">0.00</span>
        <span class="unit">元</span>
      </div>
    </div>
    <div class="protocol">
      点击开通则表示同意
      <a class="mark">《高效机房服务协议》</a>
    </div>
    <template class="footer" #footer>
      <div class="footer">
        <a-button class="btn" type="primary" style="margin-right: 8px" @click="handleOk"
          >开通</a-button
        >
        <a-button class="btn" @click="handleCancel">取消</a-button>
      </div>
    </template>
  </tsl-drawer>
</template>

<script>
import Drawer from "@/components/tsl-drawer/index.vue";
import { Table, Radio, Select, Button, message } from "ant-design-vue";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const Option = Select.Option;

export default {
  name: "drawer-machine-room",
  props: {
    service: Object
  },
  components: {
    [Drawer.name]: Drawer,
    [Table.name]: Table,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Select.name]: Select,
    [Button.name]: Button,
    [Option.name]: Option
  },
  setup() {
    const router = useRouter();
    const visible = ref(false);
    const handleCancel = () => {
      visible.value = false;
    };
    const handleOk = () => {
      message.success("开通成功");
      router.push({ path: "/dashboard" });
    };
    const showModal = () => {
      visible.value = true;
    };
    const options = ref([
      {
        value: "1",
        label: "1年"
      },
      {
        value: "2",
        label: "2年"
      }
    ]);
    const version = ref("1");
    const duration = ref("1");

    const columns = [
      {
        title: "功能模板",
        key: "template",
        dataIndex: "template"
      },
      {
        title: "计费价格",
        key: "price",
        dataIndex: "price"
      },
      {
        title: "服务优惠",
        key: "discount",
        dataIndex: "discount"
      }
    ];

    const dataSource = ref([
      {
        template: "机房监控",
        price: "¥5,000",
        discount: "¥5,000"
      },
      {
        template: "能效分析",
        price: "¥5,000",
        discount: "¥5,000"
      },
      {
        template: "报警管理",
        price: "¥5,000",
        discount: "¥5,000"
      },
      {
        template: "系统配置",
        price: "¥5,000",
        discount: "¥5,000"
      }
    ]);

    const specification = ref(true);
    const typeChecked = (e) => {
      if (e.target.value == 1) {
        specification.value = true;
        dataSource.value = [
          {
            template: "机房监控",
            price: "¥5,000",
            discount: "¥5,000"
          },
          {
            template: "能效分析",
            price: "¥5,000",
            discount: "¥5,000"
          },
          {
            template: "报警管理",
            price: "¥5,000",
            discount: "¥5,000"
          },
          {
            template: "系统配置",
            price: "¥5,000",
            discount: "¥5,000"
          }
        ];
      } else {
        specification.value = false;
        dataSource.value = [
          {
            template: "标准报表",
            price: "¥10,000",
            discount: "¥10,000"
          },
          {
            template: "设备全生命周期管理",
            price: "¥20,000",
            discount: "¥20,000"
          },
          {
            template: "工单管理",
            price: "¥20,000",
            discount: "¥20,000"
          }
        ];
      }
    };
    const amount = computed(
      () => options.value[duration.value - 1].value * (specification.value ? 30000 : 100)
    );
    const discounts = computed(
      () => options.value[duration.value - 1].value * (specification.value ? 30000 : 100)
    );
    return {
      visible,
      handleCancel,
      showModal,
      options,
      duration,
      version,
      columns,
      dataSource,
      handleOk,
      typeChecked,
      amount,
      discounts
    };
  }
};
</script>

<style lang="less" scoped>
.subscribe-service-drawer {
  .lump {
    margin-bottom: 16px;
    h5 {
      margin-bottom: 8px;
      color: #1d2129;
      font-size: 14px;
    }
    .way {
      color: #86909c;
    }
    .price {
      height: 40px;
      color: #fc8c23;
      line-height: 40px;
      .amount {
        font-size: 32px;
      }
      .unit {
        display: inline-block;
        font-size: 14px;
        transform: translateY(-5px);
      }
    }
    .ant-select {
      width: 132px;
    }
    :deep(.ant-select:not(.ant-select-customize-input) .ant-select-selector) {
      border: 1px solid #e5e6eb;
    }
    :deep(.ant-select-single .ant-select-selector .ant-select-selection-item) {
      color: #4e5969;
    }
    .ant-radio-button-wrapper {
      background-color: #f7f8fa;
      border: 1px solid #f7f8fa;
    }
    .ant-radio-button-wrapper:hover {
      color: #5d65fb;
    }
    .ant-radio-button-wrapper-checked {
      z-index: 1;
      color: #5d65fb;
      font-weight: 500;
      background: #e8edff;
      border-color: #5d65fb;
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
      background-color: #5d65fb;
    }
    .ant-radio-button-wrapper-checked:focus-within {
      box-shadow: none;
    }
    .ant-radio-button-wrapper:focus-within {
      box-shadow: none;
    }
    :deep(.ant-btn) {
      border-radius: 4px;
    }
    :deep(.ant-btn-primary) {
      text-shadow: none;
      background: #5e66f2;
      border-color: #5e66f2;
      box-shadow: none;
    }
  }
  .discount {
    color: #fc8c23;
  }
  .protocol {
    position: absolute;
    bottom: 73px;
    .mark {
      color: #5d65fb;
    }
  }
  .footer {
    :deep(.ant-btn) {
      background-color: #f2f3f5;
      border: 1px solid #f2f3f5;
      border-radius: 4px;
      box-shadow: none;
    }
    :deep(.ant-btn-primary) {
      text-shadow: none;
      background: #5e66f2;
      border-color: #5e66f2;
      box-shadow: none;
    }
    .ant-btn:hover,
    .ant-btn:focus {
      color: #5e66f2;
    }
    .ant-btn-primary:hover,
    .ant-btn-primary:focus {
      color: #fff;
    }
  }
}
.original-price {
  margin-top: 8px;
  color: #c9cdd4;
  line-height: 22px;
  text-decoration: line-through;
}
</style>
